export default __webpack_public_path__ + "static/media/profile-header.c54e220a.png";